import { IonToggle as Toggle } from "@ionic/react";

Toggle.defaultProps = {
  mode: "ios",
};

export default Toggle;
